var map = {
	"./br/PT/S1/bg105.png": 10605,
	"./br/PT/S2/bg105.png": 31593,
	"./br/PT/bg105.png": 74143,
	"./in/EN/S1/bg105.png": 47229,
	"./in/EN/S2/bg105.png": 330,
	"./in/HI/bg105.png": 42527,
	"./mx/EN/S1/bg105.png": 34647,
	"./mx/EN/bg105.png": 2696,
	"./mx/ES/bg105.png": 18800,
	"./ng/EN/S1/bg105.png": 43897,
	"./ng/EN/bg105.png": 73182,
	"./ph/EN/S1/bg105.png": 74111,
	"./ph/EN/bg105.png": 40335,
	"./vn/VI/S1/bg105.png": 78932
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46040;